import { render, staticRenderFns } from "./auth-profile-page.vue?vue&type=template&id=7396693c"
import script from "./auth-profile-page.vue?vue&type=script&lang=js"
export * from "./auth-profile-page.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports